import * as caseTypes from './casesTypes';

export const clearFilters = () => ({
  type: caseTypes.CLEAR_FILTER,
});

export const onChange = payload => ({
  type: caseTypes.ON_CHANGE,
  payload,
});

export const onChangeDate = payload => ({
  type: caseTypes.ON_CHANGE_DATE,
  payload,
});



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesFilterAction.js